import AppTour from '@components/tour/AppTour';
import { LAYER_VIEW_SIDEBAR_ID, useProject } from '@contexts/Project.context';

/**
 * `AppTour` as the project map view sees it.
 *
 * The engine is screen-agnostic; this is the one place that translates the
 * project's state into the engine's terms, so a tour on another screen writes
 * its own adapter instead of teaching the engine about projects.
 *
 * - Gone entirely in annotation mode, along with the rest of the working toolbar.
 * - Suppressed until the project has loaded, during a boundary edit, on a demo
 *   project, or on a placeholder whose imagery is still processing — the same
 *   reasons `ObjectPicker` refuses to start a run mid-edit.
 * - Supplies the `layerView` stage: opens the Layers sidebar, because it is
 *   unmounted when closed and several steps point into it. The reducer ignores
 *   the request when it is already open.
 */
const ProjectTour = ({ tourId }) => {
	const { annotationMode, boundaryEditActive, isDemo, project, setActiveSidebar } = useProject();

	if (annotationMode) return null;

	// Mirrors `ProjectMapView`'s placeholder tracking: a failed orthophoto is
	// not "still processing", so it does not hold the tour back.
	const isPlaceholder =
		!!project?.orthophoto_is_placeholder && !project?.orthophoto_progress?.error;

	return (
		<AppTour
			tourId={tourId}
			suppressed={!project || boundaryEditActive || isDemo || isPlaceholder}
			stages={{ layerView: () => setActiveSidebar({ sidebarId: LAYER_VIEW_SIDEBAR_ID }) }}
		/>
	);
};

export default ProjectTour;
